module.exports = __webpack_public_path__ + "static/media/roof-6.a02910d1.jpg";